import { render, staticRenderFns } from "./VendorAdd.vue?vue&type=template&id=607b993f"
import script from "./VendorAdd.vue?vue&type=script&lang=js"
export * from "./VendorAdd.vue?vue&type=script&lang=js"
import style0 from "./VendorAdd.vue?vue&type=style&index=0&id=607b993f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports